module.exports = __webpack_public_path__ + "static/img/4.07c1b5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/booking/department/4.png
// module id = xOAF
// module chunks = 1